import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';
import cx from 'classnames';
import React, { FC } from 'react';
import style from './Loader.module.scss';

interface Props extends SpinProps {
  fullscreen?: boolean;
}

export const Loader: FC<Props> = ({ fullscreen = false, ...props }) => {
  return (
    <div className={cx(style.overlay, { [style.fullscreen]: fullscreen })}>
      <Spin {...props} delay={200} />
    </div>
  );
};
